import {Component, Input, OnInit} from '@angular/core';
import {IForWhomItem} from './for-whoom-item/for-whoom-item.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-for-whoom',
  templateUrl: './for-whoom.component.html',
  styleUrls: ['./for-whoom.component.scss']
})
export class ForWhoomComponent implements OnInit {
  items: IForWhomItem[] = null;
  @Input() type: 'default' | 'business'| 'ai' = 'default';

  constructor(
      private lang: TranslateService
  ) { }

  ngOnInit(): void {
    const data = {
      default:  [
        {
          label: 'Prone to Stress',
          alt: 'Image representing an individual prone to stress',
          src: './assets/img/fh1_1x.webp',
          m_src: './assets/img/fh1_1x.webp',
          link: `https://blog.anima.help/${this.lang.currentLang}/intense-stress-friend-or-foe/`
        },
        {
          label: 'In Recovery',
          src: 'assets/img/fh2_1x.webp',
          m_src: 'assets/img/fh2_1x.webp',
          alt: 'Image symbolizing a person in therapy going through recovery',
          link: `https://blog.anima.help/${this.lang.currentLang}/helping-you-to-track-progress/`
        },
        {
          label: 'High-Performer',
          src: 'assets/img/fh3_1x.webp',
          m_src: 'assets/img/fh3_1x.webp',
          alt: 'Image illustrating a high-performer, focusing on achievement and excellence',
          link: `https://blog.anima.help/${this.lang.currentLang}/trauma-may-be-closer-than-you-think/`
        },
        {
          label: 'Therapist',
          src: 'assets/img/fh4_1x.webp',
          m_src: 'assets/img/fh4_1x.webp',
          alt: 'Image of a therapist, in a counseling setting, emphasizing professionalism and care in mental health.',
          link: `https://blog.anima.help/${this.lang.currentLang}/how-to-measure-the-effectiveness-of-the-therapy/`
        }
      ],
      business: [
        {
          label: 'Management',
          alt: 'Image representing an individual prone to stress',
          src: './assets/img/for_whoom/management.webp',
          m_src: './assets/img/for_whoom/management.webp',
          link: `https://blog.anima.help/${this.lang.currentLang}/the-ceos-guide-to-building-a-mentally-healthy-organization/`
        },
        {
          label: 'Human resources',
          src: './assets/img/for_whoom/hr.webp',
          m_src: './assets/img/for_whoom/hr.webp',
          alt: 'Image symbolizing a person in therapy going through recovery',
          link: `https://blog.anima.help/${this.lang.currentLang}/anima-for-hr-the-next-frontier-in-employee-well-being/`
        },
        {
          label: 'Psychologists',
          src: './assets/img/for_whoom/psy.webp',
          m_src: './assets/img/for_whoom/psy.webp',
          alt: 'Image illustrating a high-performer, focusing on achievement and excellence',
          link: `https://blog.anima.help/${this.lang.currentLang}/empowering-psychologists-with-smart-tools-for-workplace-wellness/`

        },
        {
          label: 'Employees',
          src: './assets/img/for_whoom/employees.webp',
          m_src: './assets/img/for_whoom/employees.webp',
          alt: 'Image of a therapist, in a counseling setting, emphasizing professionalism and care in mental health.',
          link: `https://blog.anima.help/${this.lang.currentLang}/take-care-of-yourself-at-work-with-anima/`

        }
      ],
      ai:  [
        {
          label: 'Prone to Stress',
          alt: 'Image representing an individual prone to stress',
          src: './assets/img/fh1_1x.webp',
          m_src: './assets/img/fh1_1x.webp',
          link: `https://blog.anima.help/${this.lang.currentLang}/intense-stress-friend-or-foe/`
        },
        {
          label: 'In Recovery',
          src: 'assets/img/fh2_1x.webp',
          m_src: 'assets/img/fh2_1x.webp',
          alt: 'Image symbolizing a person in therapy going through recovery',
          link: `https://blog.anima.help/${this.lang.currentLang}/helping-you-to-track-progress/`
        },
        {
          label: 'High-Performer',
          src: 'assets/img/fh3_1x.webp',
          m_src: 'assets/img/fh3_1x.webp',
          alt: 'Image illustrating a high-performer, focusing on achievement and excellence',
          link: `https://blog.anima.help/${this.lang.currentLang}/trauma-may-be-closer-than-you-think/`
        },
        {
          label: 'Therapist',
          src: 'assets/img/fh4_1x.webp',
          m_src: 'assets/img/fh4_1x.webp',
          alt: 'Image of a therapist, in a counseling setting, emphasizing professionalism and care in mental health.',
          link: `https://blog.anima.help/${this.lang.currentLang}/how-to-measure-the-effectiveness-of-the-therapy/`

        }
      ]
    };
    this.items = data[this.type];
  }
}
